import React from 'react';

import styles from './CustomFilter.module.scss';

const Filter = ({children}) => {
  return (
    <div className={styles.container}>
      {children}
    </div>
  )
}

export const FilterItem = ({children, onClick, active}) => {
  return (
    <button onClick={onClick} className={ active ? styles.active : ''}>
      {children}
    </button>
  )
}

export default Filter;